import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import SideBar from "./SideBar";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { activeSessionusersList } from "../../actions/AuthAction";
import constant from "../../constant";
import { DetailsListDocumentsExample } from "./TableList";
function SuperUserDashboard() {
  const router = useHistory();

  const [data, setData] = useState({
    sessions: { name: "sessions", value: [], error: "", options: [] },
  });

  const updateActiveSessions = () => {};

  useEffect(() => {
    if (window.localStorage.getItem(constant.cookie.superUserToken)) {
      getSessionList();
    } else {
      router.push(constant.component.superUser.url);
    }
  }, [data.sessions.value.length]);

  const getSessionList = async () => {
    let res = await activeSessionusersList();
    if (res.status == constant.static.apiStatus.success) {
      setData({
        ...data,
        ["sessions"]: { ...data["sessions"], value: res.result },
      });
    }
  };

  const sessionOut = () => {
    if (window.localStorage.getItem(constant.cookie.superUserToken)) {
      window.localStorage.removeItem(constant.cookie.superUserToken);
      router.push(constant.component.superUser.url);
    }
  };

  return (
    <React.Fragment>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-4 col-md-4 col-xl-2">
            <SideBar />
          </div>

          <div className="col-10 col-md-6 col-xl-10">
            <div className="col-md-12 my-3 d-flex  justify-between">
              <h1 className="page-title">Active Sessions</h1>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => {
                  sessionOut();
                }}
              >
                Logout
              </button>
            </div>

            <div>
              <div className="row mt-3">
                <div
                  className="col-md-12 "
                  style={{
                    overflow: "hidden",
                    height: "90vh",
                    overflowY: "auto",
                  }}
                >
                  <div className="card">
                    {data.sessions.value.length > 0 && (
                      <DetailsListDocumentsExample
                        details={data.sessions.value}
                        updateList={() => {
                          getSessionList();
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SuperUserDashboard;
